import { Button, Col, Row } from "antd";
import "./Order_Overview.css";
import React, { useContext, useEffect, useState } from "react";
import CheckoutStepFormContext from "../CheckoutStepFormContext";
import Light_Gray_Outline_Btn from "../../../common-components/common_btn/gray_outline_btn/Light_Gray_Outline_Btn";
import Green_Outline_Btn from "../../../common-components/common_btn/green_outline_btn/Green_Outline_Btn";
import Increment_decrement_btn_holder from "../../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Form, InputGroup, Table } from "react-bootstrap";
import Order_Overview_summery_holder from "./order_Overview_summery_holder/Order_Overview_summery_holder";
import { Link, useNavigate } from "react-router-dom";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
import Coupons_Modal from "../../../common-components/common_modal/coupons_modal/Coupons_Modal";
import { useDispatch, useSelector } from "react-redux";
import { deleteAllCart, getAllCart } from "../../../../features/cart/cartSlice";
import {
  CouponApplyed,
  createOrder,
  getSingleOrderAddress,
  OrderCalculation,
  OrderResponse,
  createRazorpayOrder,
  PaymentOnline,
} from "../../../../features/order/orderSlice";
import useRazorpay from "react-razorpay";
import { useForm } from "react-hook-form";
import Delete_Modal from "../../../common-components/common_modal/delete_modal/Delete_Modal";
import Spinner from "react-bootstrap/Spinner";
import { encodeId, variant_type, getVariantImage } from "../../../../utils/common";

const Order_Overview = ({ paymentValue, selectedAddressId }) => {
  const [modalDeleteShow, setModalDeleteShow] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);

  const [couponSuccessShow, setCouponSuccessShow] = useState(false);

  const [data, setData] = useState({});
  const { prev } = useContext(CheckoutStepFormContext);
  const navigate = useNavigate();

  const handleClick = () => {
    setModalShow(true); // Show modal

    setTimeout(() => {
      setModalShow(false); // Close modal after 3s (optional)
      navigate("/"); // Navigate after modal
    }, 3000); // Show for 3 seconds
  };

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  const [CouponData, setCouponData] = React.useState("");

  const [Errors, setErrors] = React.useState(null);
  const [loader, setLoader] = useState(false);

  const isSignin = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();
  const allcartData = useSelector((state) => state.cart.allCarts);
  useEffect(() => {
    dispatch(getAllCart(isSignin));
  }, [dispatch]);

  const orderCalculation = async (selectedAddressId, currentCurrency) => {
    setLoader(true);

    const data = {
      address_id: selectedAddressId,
      exchange_rate: currentCurrency?.rate,
    };

    if (CouponData) {
      data.coupon_id = CouponData?.id;
    }
    const res = await dispatch(OrderCalculation(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setData(res.payload.data);
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors) {
        setErrors(res.payload?.errors);
      }
    }
    await setLoader(false);
  };

  useEffect(() => {
    orderCalculation(selectedAddressId, currentCurrency);
  }, [selectedAddressId, CouponData, currentCurrency]);

  const address = useSelector((state) => state.order.orderAddress);
  useEffect(() => {
    dispatch(getSingleOrderAddress({ id: selectedAddressId }));
  }, [dispatch, selectedAddressId]);

  //order place
  const [razorid, setRazorId] = useState();
  const [Razorpay] = useRazorpay();
  const user = useSelector((state) => state.myaccount.addMyaccount);

  const handleRazorpay = async (orderData, totalAmount) => {
    // const amountInPaise = Math.round(totalAmount * 100);
    const amountInPaise = Math.round(1 * 100);
    const options = {
      // key: "rzp_test_T5kDErcCEFTvIK",
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,

      amount: amountInPaise,
      currency: "INR",
      name: "The Maa Edit",
      description: "Transaction",
      // order_id: data?.merchant_order_id,
      order_id: orderData?.merchant_order_id,

      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await setRazorId(res.razorpay_payment_id);
        // finalFunction(res.razorpay_payment_id);
        PaymentOnlineCreate(res.razorpay_payment_id, orderData);
      },
      prefill: {
        name: user.name,
        email: user.email,
        contact: user.conatct_no,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const PaymentOnlineCreate = async (razorpay_payment_id, data) => {
    const res = await dispatch(
      PaymentOnline({
        id: data.id,
        payment_id: razorpay_payment_id,
      }),
    );

    if (res.meta?.requestStatus === "fulfilled") {
      handleClick();

      await dispatch(getAllCart(isSignin));
    }
  };

  //live

  // const finalFunction = async () => {
  //   setLoader(true);
  //   const datafinal = {
  //     exchange_rate_id: currentCurrency?.id,
  //     exchange_rate: currentCurrency?.rate,
  //     address_id: selectedAddressId,
  //     payment_method_id: paymentValue,
  //     order_summary: data?.order_summary,
  //     order_Details_summary: data?.order_Details_summary,
  //   };

  //   const res = await dispatch(createOrder(datafinal));

  //   if (res.meta?.requestStatus === "fulfilled") {
  //     const redirectUrl = res?.payload?.data?.redirectUrl;

  //     if (redirectUrl) {
  //       window.location.href = redirectUrl;
  //       return;
  //     }

  //     handleClick();
  //     await dispatch(getAllCart(isSignin));
  //   } else if (res.meta?.requestStatus === "rejected") {
  //     setErrors(res.payload);
  //     console.log("Order failed");
  //   }

  //   setLoader(false);
  // };

  // const handleRazorpay = async (price) => {
  //   try {
  //     setLoader(true);
  //     setErrors(null);

  //     // 1. Create Razorpay Order from backend
  //     const razorpayOrderResponse = await dispatch(
  //       createRazorpayOrder({
  //         amount: Number(price),
  //       }),
  //     );

  //     if (razorpayOrderResponse.meta?.requestStatus !== "fulfilled") {
  //       setErrors(
  //         razorpayOrderResponse.payload || "Unable to create payment order",
  //       );

  //       setLoader(false);
  //       return;
  //     }

  //     const razorpayOrder = razorpayOrderResponse.payload?.data;

  //     console.log("Razorpay Order Created:", razorpayOrder);

  //     if (!razorpayOrder?.id) {
  //       setErrors("Razorpay order ID was not generated");
  //       setLoader(false);
  //       return;
  //     }

  //     // 2. Open Razorpay Checkout using backend-generated order_id
  //     const options = {
  //       key: process.env.REACT_APP_RAZORPAY_KEY_ID,

  //       amount: razorpayOrder.amount,

  //       currency: razorpayOrder.currency,

  //       name: "The Maa Edit",

  //       description: "Order Payment",

  //       order_id: razorpayOrder.id,

  //       handler: async (response) => {
  //         console.log("Razorpay Payment Success:", response);

  //         // 3. Send Razorpay response to backend
  //         await finalFunction({
  //           razorpay_payment_id: response.razorpay_payment_id,
  //           razorpay_order_id: response.razorpay_order_id,
  //           razorpay_signature: response.razorpay_signature,
  //         });
  //       },

  //       prefill: {
  //         name: "Piyush Garg",
  //         email: "youremail@example.com",
  //         contact: "9999999999",
  //       },

  //       notes: {
  //         address: "Razorpay Corporate Office",
  //       },

  //       theme: {
  //         color: "#052c65",
  //       },

  //       modal: {
  //         ondismiss: () => {
  //           setLoader(false);
  //         },
  //       },
  //     };

  //     const rzpay = new Razorpay(options);

  //     rzpay.open();
  //   } catch (error) {
  //     console.error("Razorpay checkout error:", error);
  //     setErrors(error?.message || "Unable to start Razorpay payment");
  //     setLoader(false);
  //   }
  // };

  //live
  // const finalFunction = async (razorpayPaymentData = null) => {
  //   try {
  //     setLoader(true);
  //     setErrors(null);

  //     const datafinal = {
  //       exchange_rate_id: currentCurrency?.id,
  //       exchange_rate: currentCurrency?.rate,
  //       address_id: selectedAddressId,
  //       payment_method_id: paymentValue,

  //       order_summary: data?.order_summary,
  //       order_Details_summary: data?.order_Details_summary,
  //     };

  //     // Add Razorpay payment information for online payment
  //     if (razorpayPaymentData) {
  //       datafinal.payment_id = razorpayPaymentData.razorpay_payment_id;

  //       datafinal.razorpay_order_id = razorpayPaymentData.razorpay_order_id;

  //       datafinal.razorpay_signature = razorpayPaymentData.razorpay_signature;
  //     }

  //     const res = await dispatch(createOrder(datafinal));

  //     if (res.meta?.requestStatus === "fulfilled") {
  //       console.log("Order Created Successfully:", res.payload);
  //       if (Number(paymentValue) === 2) {
  //         const amount = parseFloat(data?.order_summary?.total_amount);

  //         const orderData = res?.payload?.data?.order;

  //         await handleRazorpay(orderData, amount);
  //       } else {
  //         handleClick();

  //         await dispatch(getAllCart(isSignin));
  //       }
  //     } else {
  //       console.error("Order creation failed:", res.payload);

  //       setErrors(res.payload || "Unable to create order");
  //     }
  //   } catch (error) {
  //     console.error("Final order error:", error);

  //     setErrors(error?.message || "Unable to place order");
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  /* */
  const finalFunction = async (razorpayPaymentData = null) => {
    try {
      setLoader(true);
      setErrors(null);

      const datafinal = {
        exchange_rate_id: currentCurrency?.id,
        exchange_rate: currentCurrency?.rate,
        address_id: selectedAddressId,
        payment_method_id: paymentValue,

        order_summary: data?.order_summary,
        order_Details_summary: data?.order_Details_summary,
      };

      // =====================================================
      // ONLINE PAYMENT
      // =====================================================

      if (Number(paymentValue) === 2 && !razorpayPaymentData) {
        const amount = parseFloat(data?.order_summary?.total_amount);

        const razorpayOrderResponse = await dispatch(
          createRazorpayOrder({
            amount: amount,
          }),
        );

        if (razorpayOrderResponse.meta?.requestStatus !== "fulfilled") {
          setErrors(
            razorpayOrderResponse.payload || "Unable to create payment order",
          );

          return;
        }

        const razorpayOrder = razorpayOrderResponse?.payload?.data;

        if (!razorpayOrder?.id) {
          setErrors("Razorpay order ID was not generated");

          return;
        }

        console.log("Razorpay Order Created:", razorpayOrder);

        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,

          amount: razorpayOrder.amount,

          currency: razorpayOrder.currency || "INR",

          name: "The Maa Edit",

          description: "Transaction",

          order_id: razorpayOrder.id,

          image:
            "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

          handler: async (response) => {
            console.log("Razorpay Payment Success:", response);

            // ============================================
            // PAYMENT SUCCESS
            // ============================================
            // Now create your database order.
            // If user closes Razorpay, this code is NEVER
            // executed.
            // ============================================

            await finalFunction(response);
          },

          prefill: {
            name: user?.name || "",
            email: user?.email || "",
            contact: user?.conatct_no || "",
          },

          notes: {
            address: "Razorpay Corporate Office",
          },

          theme: {
            color: "#052c65",
          },

          modal: {
            ondismiss: () => {
              console.log("Razorpay payment cancelled");

              // IMPORTANT:
              // Do not call createOrder here.
              setLoader(false);
            },
          },
        };

        const rzpay = new Razorpay(options);

        rzpay.open();

        return;
      }

      // =====================================================
      // PAYMENT SUCCESS / COD
      // =====================================================

      if (razorpayPaymentData) {
        datafinal.payment_id = razorpayPaymentData.razorpay_payment_id;

        datafinal.razorpay_order_id = razorpayPaymentData.razorpay_order_id;

        datafinal.razorpay_signature = razorpayPaymentData.razorpay_signature;
      }

      // =====================================================
      // CREATE DATABASE ORDER
      // =====================================================

      const res = await dispatch(createOrder(datafinal));

      console.log("Create Order Response:", res);

      if (res.meta?.requestStatus !== "fulfilled") {
        console.error("Order creation failed:", res.payload);

        setErrors(res.payload || "Unable to create order");

        return;
      }

      console.log("Order Created Successfully:", res.payload);

      // =====================================================
      // ONLINE PAYMENT
      // =====================================================

      if (Number(paymentValue) === 2 && razorpayPaymentData) {
        const orderData = res?.payload?.data?.order;

        console.log("Database Order Data:", orderData);

        console.log("Database Order ID:", orderData?.id);

        // IMPORTANT:
        // Your existing PaymentAfterOnline backend
        // requires the DATABASE order ID.
        await PaymentOnlineCreate(
          razorpayPaymentData.razorpay_payment_id,
          orderData,
        );

        return;
      }

      // =====================================================
      // COD / OTHER PAYMENT
      // =====================================================

      handleClick();

      await dispatch(getAllCart(isSignin));
    } catch (error) {
      console.error("Final order error:", error);

      setErrors(error?.message || "Unable to place order");
    } finally {
      setLoader(false);
    }
  };

  // const finalFunction = async (razorpayPaymentData = null) => {
  //   try {
  //     setLoader(true);
  //     setErrors(null);

  //     const datafinal = {
  //       exchange_rate_id: currentCurrency?.id,
  //       exchange_rate: currentCurrency?.rate,
  //       address_id: selectedAddressId,
  //       payment_method_id: paymentValue,

  //       order_summary: data?.order_summary,
  //       order_Details_summary: data?.order_Details_summary,
  //     };

  //     // =====================================================
  //     // ONLINE PAYMENT
  //     // =====================================================
  //     if (Number(paymentValue) === 2 && !razorpayPaymentData) {
  //       const amount = parseFloat(data?.order_summary?.total_amount);

  //       // Create Razorpay order only
  //       const razorpayOrderResponse = await dispatch(
  //         createRazorpayOrder({
  //           amount: amount,
  //         }),
  //       );

  //       if (razorpayOrderResponse.meta?.requestStatus !== "fulfilled") {
  //         setErrors(
  //           razorpayOrderResponse.payload || "Unable to create payment order",
  //         );

  //         setLoader(false);
  //         return;
  //       }

  //       const razorpayOrder = razorpayOrderResponse?.payload?.data;

  //       if (!razorpayOrder?.id) {
  //         setErrors("Razorpay order ID was not generated");
  //         setLoader(false);
  //         return;
  //       }

  //       const options = {
  //         key: process.env.REACT_APP_RAZORPAY_KEY_ID,

  //         // Use actual order amount
  //         amount: razorpayOrder.amount,

  //         currency: razorpayOrder.currency || "INR",

  //         name: "The Maa Edit",

  //         description: "Transaction",

  //         order_id: razorpayOrder.id,

  //         image:
  //           "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

  //         handler: async (response) => {
  //           console.log("Razorpay Payment Success:", response);

  //           // ONLY AFTER PAYMENT SUCCESS
  //           await finalFunction(response);
  //         },

  //         prefill: {
  //           name: user?.name || "",
  //           email: user?.email || "",
  //           contact: user?.conatct_no || "",
  //         },

  //         notes: {
  //           address: "Razorpay Corporate Office",
  //         },

  //         theme: {
  //           color: "#052c65",
  //         },

  //         // IMPORTANT
  //         modal: {
  //           ondismiss: () => {
  //             console.log("Razorpay payment cancelled");

  //             setLoader(false);

  //             // Do NOTHING here.
  //             // createOrder() will NOT be called.
  //           },
  //         },
  //       };

  //       const rzpay = new Razorpay(options);

  //       rzpay.open();

  //       return;
  //     }

  //     // =====================================================
  //     // PAYMENT SUCCESS / COD
  //     // =====================================================

  //     // If Razorpay payment was successful,
  //     // add Razorpay details before creating order
  //     if (razorpayPaymentData) {
  //       datafinal.payment_id = razorpayPaymentData.razorpay_payment_id;

  //       datafinal.razorpay_order_id = razorpayPaymentData.razorpay_order_id;

  //       datafinal.razorpay_signature = razorpayPaymentData.razorpay_signature;
  //     }

  //     const res = await dispatch(createOrder(datafinal));

  //     if (res.meta?.requestStatus === "fulfilled") {
  //       console.log("Order Created Successfully:", res.payload);

  //       handleClick();

  //       await dispatch(getAllCart(isSignin));
  //     } else {
  //       console.error("Order creation failed:", res.payload);

  //       setErrors(res.payload || "Unable to create order");
  //     }
  //   } catch (error) {
  //     console.error("Final order error:", error);

  //     setErrors(error?.message || "Unable to place order");
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (d) => {
    d.amount = data?.order_summary?.total_selling_price;

    const res = await dispatch(CouponApplyed(d));

    clearErrors();

    if (res?.payload?.data) {
      setCouponData(res?.payload?.data);

      setValue("code", d?.code);

      setShowCouponModal(false);
      setCouponSuccessShow(true);
    }
    if (res?.payload?.errors) {
      setError("code", {
        type: "manual",
        message: res.payload?.errors,
      });

      setShowCouponModal(false);
    }
  };

  const deleteCart = async (id, product_id, varient_id) => {
    const res = await dispatch(
      deleteAllCart({ id, isSignin, product_id, varient_id }),
    );
    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllCart(isSignin));
      await orderCalculation(selectedAddressId);
    } else if (res.meta?.requestStatus === "rejected") {
      console.log("Error:", res.payload || "Not In Cart");
    }
  };

  return (
    <>
      <div className={"Cart_Products_card Order_Overview"}>
        <div className="row">
          <div className="col-md-7">
            <div className="desktop_viw_table_holder">
              <div className="table-responsive">
                <Table>
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th className="text-end">
                        <b>Total</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {allcartData?.data?.length > 0 ? (
                      allcartData?.data?.map((val) => {
                        let stock;
                        if (
                          Number(val?.Product?.variant_type_id) ===
                          Number(variant_type.Single)
                        ) {
                          stock = Number(val?.Product_Variant?.general_stock);
                        } else if (
                          Number(val?.Product?.variant_type_id) ===
                          Number(variant_type.Double)
                        ) {
                          stock = Number(val?.Double_Variant?.stock);
                        } else if (
                          Number(val?.Product?.variant_type_id) ===
                          Number(variant_type.Triple)
                        ) {
                          stock = Number(val?.Triple_Variant?.stock);
                        }
                        const isInstock = stock <= val?.quantity;
                        const isInstockerror = stock < val?.quantity;

                        const quantity = Number(val?.quantity);

                        const mrp = Number(
                          val.Triple_Variant?.mrp ||
                            val.Double_Variant?.mrp ||
                            val.Product_Variant?.mrp,
                        );

                        const price = Number(
                          val.Triple_Variant?.price ||
                            val.Double_Variant?.price ||
                            val.Product_Variant?.price,
                        );

                        const finalmrp = Number(mrp * rate).toFixed(2);
                        const finalprice = Number(price * rate).toFixed(2);

                        return (
                          <tr
                            key={
                              val.id ?? `${val.product_id}-${val.variant_id}`
                            }
                          >
                            <td>
                              <div className="row">
                                <div
                                  className="col-md-4 col-12"
                                  onClick={() =>
                                    navigate(
                                      `/product-details/${encodeId(
                                        val.product_id,
                                      )}`,
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="img_holder">
                                    <img
                                      className="Product_img"
                                      src={getVariantImage(val)}
                                      alt={val.Product?.name || "Product image"}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-8 col-12">
                                  <div className="info_text_holder">
                                    <div>
                                      <h4>{val.Product?.name}</h4>
                                      <p className="price_text">
                                        {symbol} {finalprice}
                                        <span>
                                          {symbol} {finalmrp}
                                        </span>
                                      </p>
                                      <h6>
                                        {val?.Product?.variant_type_id ===
                                          variant_type.Single && (
                                          <>
                                            <b>
                                              <strong className="text_bold_holder">
                                                {val?.Product?.variant_name ||
                                                  "Color"}
                                                :
                                              </strong>{" "}
                                            </b>
                                            {val?.Product_Variant?.Metal?.name}
                                          </>
                                        )}

                                        {val?.Product?.variant_type_id ===
                                          variant_type.Double && (
                                          <>
                                            <b>
                                              <strong className="text_bold_holder">
                                                {val?.Product?.variant_name ||
                                                  "Color"}
                                                :
                                              </strong>{" "}
                                            </b>
                                            {
                                              val?.Double_Variant
                                                ?.Product_Variant?.Metal?.name
                                            }
                                            ,
                                            <b>
                                              <strong className="text_bold_holder">
                                                {" "}
                                                Size:
                                              </strong>{" "}
                                            </b>
                                            {
                                              val?.Double_Variant?.Size?.name
                                            }{" "}
                                          </>
                                        )}

                                        {val?.Product?.variant_type_id ===
                                          variant_type.Triple && (
                                          <>
                                            {/* <strong>Metal:</strong>{" "}
                                              {
                                                val?.Triple_Variant?.Double_Variant
                                                  ?.Product_Variant?.Metal?.name
                                              }
                                              ,  */}
                                            <b>
                                              <strong className="text_bold_holder">
                                                {" "}
                                                Size:
                                              </strong>{" "}
                                            </b>
                                            {
                                              val?.Triple_Variant
                                                ?.Double_Variant?.Size?.name
                                            }
                                            ,{" "}
                                            <b>
                                              <strong className="text_bold_holder">
                                                {" "}
                                                Diamond:
                                              </strong>{" "}
                                            </b>
                                            {val?.Triple_Variant?.Diamond?.name}
                                          </>
                                        )}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="price_holder">
                                <p className="price_text">
                                  {symbol}{" "}
                                  {Number(
                                    finalprice * Number(val.quantity),
                                  ).toFixed(2)}{" "}
                                  <span>
                                    {symbol}{" "}
                                    {Number(
                                      finalmrp * Number(val.quantity),
                                    ).toFixed(2)}
                                  </span>
                                </p>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={3} className="text-center">
                          No Data Available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>

            <div className="mobile_view_table_holder">
              {allcartData?.data?.map((val, index) => {
                let stock;
                if (
                  Number(val?.Product?.variant_type_id) ===
                  Number(variant_type.Single)
                ) {
                  stock = Number(val?.Product_Variant?.general_stock);
                } else if (
                  Number(val?.Product?.variant_type_id) ===
                  Number(variant_type.Double)
                ) {
                  stock = Number(val?.Double_Variant?.stock);
                } else if (
                  Number(val?.Product?.variant_type_id) ===
                  Number(variant_type.Triple)
                ) {
                  stock = Number(val?.Triple_Variant?.stock);
                }
                const isInstock = stock <= val?.quantity;
                const isInstockerror = stock < val?.quantity;
                const quantity = Number(val?.quantity);
                // ✅ get mrp & price for each item
                const mrp = Number(
                  val?.Product_Variant?.mrp ||
                    val?.Double_Variant?.mrp ||
                    val?.Triple_Variant?.mrp ||
                    0,
                );

                const price = Number(
                  val?.Product_Variant?.price ||
                    val?.Double_Variant?.price ||
                    val?.Triple_Variant?.price ||
                    0,
                );

                // ✅ convert with currency rate
                const finalmrp = `${symbol} ${(mrp * rate).toFixed(2)}`;
                const finalprice = `${symbol} ${(price * rate).toFixed(2)}`;

                return (
                  <div className="mobile_product_card" key={index}>
                    <div className="commmon_product_holder">
                      <div className="left_div">
                        <div className="img_holder">
                          <img
                            src={
                              getVariantImage(val)
                            }
                            className="prod_img"
                            alt="product"
                          />
                        </div>
                      </div>

                      <div className="right_div">
                        <div className="descn_holder">
                          <p className="product_name">{val?.Product?.name}</p>

                          {/* ✅ price display */}
                          <p className="price_text">
                            {finalprice}
                            <span className="mrp_text">{finalmrp}</span>
                          </p>

                          <p className="weight_text">
                            Size:
                            <span>
                              {val?.Product_Variant?.Metal?.name ||
                                val?.Double_Variant?.Product_Variant?.Metal
                                  ?.name ||
                                val?.Triple_Variant?.Double_Variant
                                  ?.Product_Variant?.Metal?.name}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* old code */}

            {/* <div className="table-responsive">
              <Table>
                <tbody>
                  {allcartData?.data?.map((val) => (
                    <tr>
                      <td>
                        <div className="row">
                          <div className="col-md-4 col-12">
                            <div className="img_holder">
                              <img
                                className="Product_img"
                                src={
                                  getVariantImage(val)
                                }
                                alt={"Product_img"}
                              />
                            </div>
                          </div>
                          <div className="col-md-8 col-12">
                            <div className="info_text_holder">
                              <div>
                                <h4>{val.Product?.name}</h4>
                                <p className="sale_price">
                                  Sale Price: {symbol}
                                  {Number(
                                    Number(
                                      val.Product_Variant?.price ||
                                        val.Double_Variant?.price ||
                                        val.Triple_Variant?.price,
                                    ) * rate,
                                  ).toFixed(2)}{" "}
                                  <span>
                                    MRP:
                                    {symbol}
                                    {Number(
                                      Number(
                                        val.Product_Variant?.mrp ||
                                          val.Double_Variant?.mrp ||
                                          val.Triple_Variant?.mrp,
                                      ) * rate,
                                    ).toFixed(2)}{" "}
                                  </span>
                                </p>
                                <h6>
                                  {val?.Product?.variant_type_id ===
                                    variant_type.Single && (
                                    <>
                                      <strong>
                                        {val?.Product?.variant_name || "Color"}:
                                      </strong>{" "}
                                      {val?.Product_Variant?.Metal?.name}
                                    </>
                                  )}

                                  {val?.Product?.variant_type_id ===
                                    variant_type.Double && (
                                    <>
                                      <strong>
                                        {val?.Product?.variant_name}:
                                      </strong>{" "}
                                      {
                                        val?.Double_Variant?.Product_Variant
                                          ?.Metal?.name
                                      }
                                      , <strong>Size:</strong>{" "}
                                      {val?.Double_Variant?.Size?.name}{" "}
                                    </>
                                  )}

                                  {val?.Product?.variant_type_id ===
                                    variant_type.Triple && (
                                    <>
                                      <strong>Size:</strong>{" "}
                                      {
                                        val?.Triple_Variant?.Double_Variant
                                          ?.Product_Variant?.Metal?.name
                                      }
                                      , <strong>Size:</strong>{" "}
                                      {
                                        val?.Triple_Variant?.Double_Variant
                                          ?.Size?.name
                                      }
                                      , <strong>Diamond:</strong>{" "}
                                      {val?.Triple_Variant?.Diamond?.name}
                                    </>
                                  )}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div className="Quantity_tr_holder">
                          <div className="price_holder">
                            <p className="mb-0">
                              {symbol}{" "}
                              {Number(
                                Number(
                                  val.Product_Variant?.price ||
                                    val.Double_Variant?.price ||
                                    val.Triple_Variant?.price,
                                ) * rate,
                              ).toFixed(2) * Number(val.quantity)}
                              <span>
                                {symbol}{" "}
                                {Number(
                                  Number(
                                    val.Product_Variant?.mrp ||
                                      val.Double_Variant?.mrp ||
                                      val.Triple_Variant?.mrp,
                                  ) * rate,
                                ).toFixed(2) * Number(val.quantity)}{" "}
                              </span>
                            </p>{" "}
                            <br />
                          </div>
                          <FontAwesomeIcon
                            className="trash_icon ms-3"
                            icon={faTrashCan}
                            onClick={() =>
                              deleteCart(
                                val?.id,
                                val?.product_id,
                                val?.variant_id,
                              )
                            }
                          />
                        </div>

                        <div className="Quantity_tr_holder">
                          <div className="price_holder">
                            <p className="mb-0">Qty: {val?.quantity} </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>  */}
          </div>

          <div className="col-md-5">
            <div className="order_summery_div">
              <Order_Overview_summery_holder
                data={data}
                address={address}
                paymentValue={paymentValue}
              />
              <div style={{ color: "red" }}>{Errors}</div>
              {errors.code && (
                <div style={{ color: "red" }}>{errors?.code?.message}</div>
              )}

              {/* <div className="Rewards_text_holder">
              <h4>Offers and Rewards</h4>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <InputGroup className="mb-3">
                  <InputGroup.Text
                    className="tags_icon_holder"
                    id="basic-addon2"
                  >
                    {" "}
                    <FontAwesomeIcon className="tags_icon" icon={faTags} />
                  </InputGroup.Text>

                  <Form.Control
                    className="mb-0"
                    placeholder="Enter Coupon Code"
                    {...register("code", {
                      required: "Coupon code is required",
                    })}
                    readOnly={!!CouponData}
                  />

                  {CouponData ? (
                    <InputGroup.Text
                      as="button"
                      type="submit"
                      className="view_grp"
                      id="basic-addon2"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setCouponData("");
                        setValue("code", "");
                      }}
                    >
                      Remove
                    </InputGroup.Text>
                  ) : (
                    <InputGroup.Text
                      className="view_grp"
                      id="basic-addon2"
                      onClick={() => setShowCouponModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      View
                    </InputGroup.Text>
                  )}
                </InputGroup>
              </Form>
            </div> */}

              <div className="Rewards_text_holder">
                <h4>Coupon Code</h4>

                <Form onSubmit={handleSubmit(onSubmit)}>
                  <InputGroup className="mb-3">
                    <InputGroup.Text
                      className="tags_icon_holder"
                      id="basic-addon2"
                    >
                      <FontAwesomeIcon className="tags_icon" icon={faTags} />
                    </InputGroup.Text>

                    <Form.Control
                      className="mb-0"
                      placeholder="Enter Coupon Code"
                      {...register("code", {
                        required: "Coupon code is required",
                      })}
                      readOnly={!!CouponData}
                    />

                    {CouponData ? (
                      <InputGroup.Text
                        as="button"
                        type="button"
                        className="view_grp"
                        id="basic-addon2"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setCouponData("");
                          setValue("code", "");
                          clearErrors("code");
                        }}
                      >
                        Remove
                      </InputGroup.Text>
                    ) : (
                      <>
                        <InputGroup.Text
                          as="button"
                          type="submit"
                          className="view_grp"
                          id="basic-addon2"
                          style={{ cursor: "pointer" }}
                        >
                          Apply
                        </InputGroup.Text>

                        <InputGroup.Text
                          className="view_grp"
                          id="basic-addon2"
                          onClick={() => setShowCouponModal(true)}
                          style={{ cursor: "pointer" }}
                        >
                          View
                        </InputGroup.Text>
                      </>
                    )}
                  </InputGroup>
                </Form>
              </div>

              {loader ? (
                <>
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </>
              ) : (
                <>
                  <div className="btn_holder d-flex justify-content-center">
                    <Green_Outline_Btn btnText={"Back"} onClick={prev} />
                    {allcartData?.data?.length > 0 ? (
                      <Green_Outline_Btn
                        btnText={"Place Order"}
                        onClick={() =>
                          paymentValue !== 2 ? finalFunction() : finalFunction()
                        }
                        // onClick={() => finalFunction()}
                      />
                    ) : (
                      <Green_Outline_Btn
                        btnText={"Continue Shopping"}
                        onClick={() => navigate("/categories")}
                      />
                      // <Link to="/categories" className="btn btn-outline-success">
                      //   Continue Shopping
                      // </Link>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Success_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText="Your Order Has Been Placed Successfully!"
      />

      <Success_Modal
        show={couponSuccessShow}
        onHide={() => setCouponSuccessShow(false)}
        successText="Coupon Applied Successfully!"
      />

      <Coupons_Modal
        setValue={setValue}
        setCouponData={setCouponData}
        onSubmit={onSubmit}
        data={data}
        show={showCouponModal}
        onHide={() => {
          setShowCouponModal(false);
        }}
      />

      <Delete_Modal
        show={modalDeleteShow}
        onHide={() => setModalDeleteShow(false)}
        successText="Order Deleted Sucessfuly"
      />
    </>
  );
};
export default Order_Overview;
